import React from 'react'
import { up } from 'styled-breakpoints'
import styled from 'styled-components'

import { useTranslation } from 'react-i18next'
import { config, StoreList } from '../../../config'

type StoreButtonProps = {
    name: keyof StoreList
    image: string
    even: boolean
}

const StoreButton: React.FunctionComponent<StoreButtonProps> = ({ image, name, even }) => {
    const { i18n } = useTranslation()
    let url = config.stores[name][i18n.language]
    if (url == null) {
        url = config.stores[name]['en']
    }

    return (
        <Container href={url} target={'_blank'} even={even} onClick={() => sendEvent(name)}>
            <Image src={image} even={even}/>
        </Container>
    )
}

const sendEvent = (name: string) => {
    // @ts-ignore
    gtag('event', 'install_app', {
        'event_category': 'conversion',
        'store': name,
    })
}

const Container = styled.a<{even: boolean}>`
    position: relative;

    display: grid;

    /* justify-items: center; */
    padding: 0;
    width: 100%;

    height: 40px;

    ${up('mobileBig')} {
        height: 44px;
    }

`

const Image = styled.img<{even: boolean}>`
    height: 100%;
    position: absolute;
    top: 0;
    ${p => p.even ? 'left: 0' : 'right: 0'};
`

export default StoreButton